export const TIME_PICKER_ACTIONS = ['accept'] as const;
export const TIME_PICKER_ACTIONS_WITH_NOW = ['today', 'accept'] as const;
export const TIME_PICKER_COLUMN_ARROW_BUTTON_CLASS_NAME = 'f-time-picker-column-arrow-button';
export const TIME_PICKER_COLUMN_ARROW_CLASS_NAME = 'f-time-picker-column-arrow';
export const TIME_PICKER_COLUMN_ARROW_DOWN_CLASS_NAME = 'f-time-picker-column-arrow-down';
export const TIME_PICKER_COLUMN_ARROW_UP_CLASS_NAME = 'f-time-picker-column-arrow-up';
export const TIME_PICKER_MERIDIEM_COLUMN_CLASS_NAME = 'f-time-picker-meridiem-column';
export const TIME_PICKER_SCROLL_STEP = 34;
export const TIME_PICKER_DEFAULT_TIME_STEPS = { minutes: 1 } as const;
export const TIME_PICKER_DEFAULT_PLACEHOLDER = 'Select time';
export const TIME_PICKER_LOCALE_TEXT = {
  okButtonLabel: 'OK',
  todayButtonLabel: 'NOW',
} as const;
export const TIME_PICKER_SINGLE_COLUMN_THRESHOLD = 0;
